import React from 'react'
import { Card, CardBody } from 'reactstrap'

type TItemTone = 'default' | 'primary' | 'warning' | 'success' | 'danger'

export type TServiceKeyValueItem = {
    label: string
    value: React.ReactNode
    tone?: TItemTone
}

type TProps = {
    title: string
    items: TServiceKeyValueItem[]
    className?: string
}

const valueClassByTone: Record<TItemTone, string> = {
    default: '',
    primary: 'text-primary',
    warning: 'text-warning',
    success: 'text-success',
    danger: 'text-danger',
}

const ServiceKeyValueCard: React.FC<TProps> = ({
    title,
    items,
    className = '',
}) => (
    <Card
        className={`service-detail-card shadow-sm border-0 h-100 ${className}`.trim()}
    >
        <CardBody>
            <div className="service-detail-card__title">{title}</div>
            <div className="service-detail-card__list">
                {items.map((item) => (
                    <div
                        className="service-detail-card__item"
                        key={`${item.label}-${String(item.value)}`}
                    >
                        <div className="service-detail-card__label">
                            {item.label}
                        </div>
                        <div
                            className={`service-detail-card__value ${
                                valueClassByTone[item.tone || 'default']
                            }`.trim()}
                            style={{ minWidth: 0 }}
                        >
                            {item.value}
                        </div>
                    </div>
                ))}
            </div>
        </CardBody>
    </Card>
)

export default ServiceKeyValueCard
